module.exports = __webpack_public_path__ + "img/icon2.51342b34.png";